<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mask } from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

import moment from 'moment'
moment.locale('pt-br')

/**
 * Produtor rural Component
 */
export default {
  directives: { mask },
  components: {
    Layout,
    Loading,
    DatePicker,
  },
  data() {
    return {
      mostraForm: true,
      showModal: false,
      isLoading: false,
      rows: 0,
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Vídeos</div>
            <div class="subTitulo"
              >Visualize os vídeos de demonstração da Plataforma.</div
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>

            <div class="card-body">
              <h4 class="mb-3 mt-0 header-title">Tutoriais</h4>
              <div class="row bg-light p-3">
                <div>
                  <b-card>
                    <b-card-title>
                      <h5 class="card-title font-size-16"
                        >Cadastro de Produtor</h5
                      >
                    </b-card-title>                    
                    <iframe
                      width="500"
                      height="300"
                      src="https://www.youtube.com/embed/sJ6X0Qr2yww"
                    >
                    </iframe>
                  </b-card>
                </div>
                <div>
                  <b-card>
                    <b-card-title>
                      <h5 class="card-title font-size-16"
                        >Cadastro de Responsável Técnico</h5
                      >
                    </b-card-title>                   
                    <iframe
                      width="500"
                      height="300"
                      src="https://www.youtube.com/embed/cUpZ5gZdtLU"
                    >
                    </iframe>
                  </b-card>
                </div>
                <div>
                  <b-card>
                    <b-card-title>
                      <h5 class="card-title font-size-16"
                        >Emissão de Receita Agronômica</h5
                      >
                    </b-card-title>

                    <iframe
                      width="500"
                      height="300"
                      src="https://www.youtube.com/embed/KQgom-hkYNc?list=PLWsClkH07MD8449t0PfubpdE_gbg-nuXd&index=1?autoplay=0&mute=1"
                    >
                    </iframe>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="borda"></div>
    </div>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>